import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from "lodash";
import { RootState } from "redux/store";

export interface Address {
  displayName: string;
  legalName: string;
  buildingNumber: string;
  floorNumber: string;
  district: string;
  location: string;
  buildingName: string;
  street: string;
  city: string;
  state: string;
  pincode: string;
  email: string;
  primaryContactEmail?: string;
  mobileNumber: string;
  locationOfSupply: string;
  countryCode: string;
  tag?: string;
  panNumber?: string;
  gstNumber?: string;
  msmeType?: string | null;
  msmeNumber?: string | null;
}

export interface IState {
  receiptNumber: string;
  receiptNumberType: "AUTO_GENERATED" | "MANUAL";
  prefix: string;
  rcpNumber: string;
  receiptDate: string | null;
  client: number | null;
  clientType: string | null;
  type: "INVOICE" | "TASK" | "ADVANCE";
  amount: number;
  previousCredits: number;
  paymentMode:
  | "CASH"
  | "CREDIT_CARD"
  | "CHEQUE"
  | "BANK_TRANSFER_NEFT_RTGS_IMPS"
  | "UPI"
  | "DEBIT_CARD";
  paymentDate: string | null;
  referenceNumber: string;
  tds: string;
  tdsAmount: number;
  creditsUsed: number;
  totalCredits: number;
  particulars: Array<any>;
  invoices: Array<any>;
  whatsappCheck: boolean;
  //new
  billingEntity: number | null;
  billingEntityAddress: Address | null;
  shippingAddress: Address | null;
  logoUrl: string;
  signatureUrl: string;
  termsAndConditionsCopy: Array<string>;
  selectedInvoices: Array<any>;
  selectedInvoicesInInv: Array<any>;
  fixedLowerBoundary: number;
  fixedAmount: number;
  fromInvoice: boolean;
  avaliableCredits: number;
  emailCheck: boolean;
  selectedd: Array<any>;
  removedRps: Array<any>;
  invoiceIds: Array<number>;
  selected: Array<any>;
  isZohoConnect: boolean;
}

const initialState: IState = {
  receiptNumber: "",
  receiptNumberType: "AUTO_GENERATED",
  prefix: "",
  rcpNumber: "",
  receiptDate: null,
  client: null,
  clientType: null,
  type: "INVOICE",
  particulars: [],
  amount: 0,
  previousCredits: 0,
  totalCredits: 0,
  paymentMode: "UPI",
  paymentDate: null,
  referenceNumber: "",
  tds: "",
  tdsAmount: 0,
  creditsUsed: 0,
  invoices: [],
  whatsappCheck: false,
  //new
  billingEntity: null,
  billingEntityAddress: null,
  shippingAddress: null,
  logoUrl: "",
  signatureUrl: "",
  termsAndConditionsCopy: [],
  selectedInvoices: [],
  selectedInvoicesInInv: [],
  fixedLowerBoundary: 0,
  fixedAmount: 0,
  fromInvoice: false,
  emailCheck: false,
  avaliableCredits: 0,
  selectedd: [],
  removedRps: [],
  invoiceIds: [],
  selected: [],
  isZohoConnect: false,
};

export const createReceiptSlice = createSlice({
  name: "createReceipt",
  initialState: _.cloneDeep(initialState),
  reducers: {
    handleChange(state: IState, action: PayloadAction<{ key: string; value: any }>) {
      // if (action.payload.key === "invoices") {
      //   const aa = (state[action.payload.key].find(i => i.id === action.payload.value.id));
      //   state[action.payload.key].push(action.payload.value);
      // } else {
      state[action.payload.key] = action.payload.value;
      // }
    },
    handleInvoiceChnage(state: IState, action: PayloadAction<{ key: string; value: any }>) {
      state[action.payload.key] = action.payload.value;
    },
    handleAddInvoice(state: IState, action: PayloadAction<{ key: string; value: any }>) {
      const existing: any[] = state.invoices.map((i) => i.invoice.id);
      const filter = action.payload.value.filter((j) => !existing.includes(j.invoice.id));

      state[action.payload.key].push(...filter);
    },
    handleWhatsapp(state: IState, action: PayloadAction<any>) {
      const data = action.payload;
      state.whatsappCheck = data;
    },

    handleMail(state: IState, action: PayloadAction<any>) {
      const data = action.payload;
      state.emailCheck = data;
    },

    resetState(state: IState) {
      Object.keys(state).forEach((key) => {
        state[key] = initialState[key];
      });
    },
    resetFormFields(state: IState) {
      // Preserve these fields that should not be reset when changing receipt type
      const preservedFields = {
        billingEntity: state.billingEntity,
        billingEntityAddress: state.billingEntityAddress,
        logoUrl: state.logoUrl,
        signatureUrl: state.signatureUrl,
        termsAndConditionsCopy: [...state.termsAndConditionsCopy],
        receiptNumber: state.receiptNumber,
        receiptNumberType: state.receiptNumberType,
        prefix: state.prefix,
        rcpNumber: state.rcpNumber,
        fromInvoice: state.fromInvoice,
        isZohoConnect: state.isZohoConnect,
        // Preserve client selection - user already selected it
        client: state.client,
        clientType: state.clientType,
        shippingAddress: state.shippingAddress,
        // Preserve receipt date and payment details
        receiptDate: state.receiptDate,
        paymentDate: state.paymentDate,
      };

      // Reset only the fields that should clear when type changes
      state.receiptNumber = preservedFields.receiptNumber;
      state.receiptNumberType = preservedFields.receiptNumberType;
      state.prefix = preservedFields.prefix;
      state.rcpNumber = preservedFields.rcpNumber;
      state.receiptDate = preservedFields.receiptDate;
      state.client = preservedFields.client;
      state.clientType = preservedFields.clientType;
      state.type = initialState.type;
      state.amount = initialState.amount;
      state.previousCredits = initialState.previousCredits;
      state.paymentMode = initialState.paymentMode;
      state.paymentDate = preservedFields.paymentDate;
      state.referenceNumber = initialState.referenceNumber;
      state.tds = initialState.tds;
      state.tdsAmount = initialState.tdsAmount;
      state.creditsUsed = initialState.creditsUsed;
      state.totalCredits = initialState.totalCredits;
      state.particulars = [];
      state.invoices = [];
      state.whatsappCheck = initialState.whatsappCheck;
      state.billingEntity = preservedFields.billingEntity;
      state.billingEntityAddress = preservedFields.billingEntityAddress;
      state.shippingAddress = preservedFields.shippingAddress;
      state.logoUrl = preservedFields.logoUrl;
      state.signatureUrl = preservedFields.signatureUrl;
      state.termsAndConditionsCopy = preservedFields.termsAndConditionsCopy;
      state.selectedInvoices = [];
      state.selectedInvoicesInInv = [];
      state.fixedLowerBoundary = initialState.fixedLowerBoundary;
      state.fixedAmount = initialState.fixedAmount;
      state.fromInvoice = preservedFields.fromInvoice;
      state.avaliableCredits = initialState.avaliableCredits;
      state.emailCheck = initialState.emailCheck;
      state.selectedd = [];
      state.removedRps = [];
      state.invoiceIds = [];
      state.selected = [];
      state.isZohoConnect = preservedFields.isZohoConnect;
    },
    handleBillingEntityChange(state: IState, action: PayloadAction<{ billingEntity: any }>) {
      let billEntity = action.payload.billingEntity;
      state.billingEntity = billEntity?.id;
      let address = {
        legalName: billEntity?.tradeName,
        displayName: billEntity?.displayName,
        buildingNumber: billEntity?.buildingNumber,
        floorNumber: billEntity?.floorNumber,
        location: billEntity?.location,
        district: billEntity?.district,
        buildingName: billEntity?.buildingName,
        street: billEntity?.street,
        city: billEntity?.city,
        state: billEntity?.state,
        pincode: billEntity?.pincode,
        email: billEntity?.email,
        primaryContactEmail: billEntity?.primaryContactEmail,
        mobileNumber: billEntity?.mobileNumber,
        locationOfSupply: billEntity?.locationOfSupply,
        countryCode: billEntity?.countryCode,
        tag: billEntity?.tag,
        panNumber: billEntity?.panNumber,
        gstNumber: billEntity?.gstNumber,
        msmeType: billEntity?.msmeType ?? null,
        msmeNumber: billEntity?.msmeNumber ?? null,
      };
      state.billingEntityAddress = address;
      state.isZohoConnect = billEntity?.isZohoConnect && !billEntity?.isEInvoiceEnabled;
      state.logoUrl = billEntity?.logStorage?.fileUrl || "";
      state.signatureUrl = billEntity?.signatureStorage?.fileUrl || "";
    },

    handleClientChange(state: IState, action: PayloadAction<{ client: any }>) {
      let client = action.payload.client;
      state.client = client?.id;
      state.clientType = client?.type;
      let address = {
        displayName: client?.displayName,
        legalName: client?.tradeName || client?.legalName || client?.displayName,
        buildingName: client?.buildingName,
        street: client?.street,
        city: client?.city,
        state: client?.state,
        pincode: client?.pincode,
        gstTreatment: "",
        gstIn: client?.gstIn,
        email: client?.email,
        mobileNumber: client?.mobileNumber,
        coutryCode: client?.countryCode,
      };
      if (client?.address?.billingfulladdress && client?.address?.shippingfulladdress) {
        const tempBillingAddress = JSON.parse(JSON.stringify(client?.address));
        const tempShippingAddress = JSON.parse(JSON.stringify(client?.address));
        tempBillingAddress["mobileNumber"] = client?.mobileNumber;
        tempBillingAddress["email"] = client?.email;
        tempBillingAddress["displayName"] = client?.displayName;
        tempShippingAddress["mobileNumber"] = client?.mobileNumber;
        tempShippingAddress["email"] = client?.email;
        tempShippingAddress["legalName"] = client?.tradeName || client?.legalName || client?.displayName;
        tempBillingAddress["countryCode"] = client?.countryCode;
        tempShippingAddress["panNumber"] = client?.panNumber;
        tempShippingAddress["gstNumber"] = client?.gstNumber;
        tempBillingAddress["billingfulladdress"] = client?.address?.billingfulladdress;
        state.shippingAddress = tempShippingAddress;
      } else {
        const tempBillingAddress = {
          displayName: "",
          legalName: "",
          buildingNumber: "",
          floorNumber: "",
          district: "",
          location: "",
          buildingName: "",
          street: "",
          city: "",
          state: "",
          pincode: "",
          email: "",
          mobileNumber: "",
          locationOfSupply: "",
          countryCode: "",
          tag: ''
        };
        tempBillingAddress["mobileNumber"] = client?.mobileNumber;
        tempBillingAddress["email"] = client?.email;
        tempBillingAddress["legalName"] = client?.tradeName || client?.legalName || client?.displayName;
        tempBillingAddress["displayName"] = client?.displayName;
        tempBillingAddress["countryCode"] = client?.countryCode;
        tempBillingAddress["panNumber"] = client?.panNumber;
        tempBillingAddress["gstNumber"] = client?.gstNumber;
        tempBillingAddress["billingfulladdress"] = client?.address?.billingfulladdress ? client?.address?.billingfulladdress : "";
        state.shippingAddress = tempBillingAddress;
      }
    },
    handleExistingClientChange(state: IState, action: PayloadAction<any>) {
      let client = action.payload.client;
      state.client = client?.id;
      let address = {
        displayName: client?.displayName,
        legalName: client?.tradeName || client?.legalName || client?.displayName,
        buildingName: client?.buildingName,
        street: client?.street,
        city: client?.city,
        state: client?.state,
        pincode: client?.pincode,
        gstTreatment: "",
        gstIn: client?.gstIn,
        email: client?.email,
        mobileNumber: client?.mobileNumber,
        countryCode: client?.countryCode,
      };
      if (client?.address?.billingaddress) {
        const tempBillingAddress = JSON.parse(JSON.stringify(client?.address?.billingaddress));
        const tempShippingAddress = JSON.parse(JSON.stringify(client?.address?.shippingaddress));
        tempBillingAddress["mobileNumber"] = client?.mobileNumber;
        tempBillingAddress["email"] = client?.email;
        tempBillingAddress["displayName"] = client?.displayName;
        tempShippingAddress["mobileNumber"] = client?.mobileNumber;
        tempShippingAddress["email"] = client?.email;
        tempShippingAddress["legalName"] = client?.tradeName || client?.legalName || client?.displayName;
        tempShippingAddress["countryCode"] = client?.countryCode;
        tempShippingAddress["panNumber"] = client?.panNumber;
        tempShippingAddress["gstNumber"] = client?.gstNumber;
        tempBillingAddress["billingfulladdress"] = client?.address?.billingfulladdress ? client?.address?.billingfulladdress : "";
        state.shippingAddress = tempBillingAddress;
        state.shippingAddress = tempShippingAddress;
      } else {
        const tempBillingAddress = {
          displayName: "",
          legalName: "",
          buildingNumber: "",
          floorNumber: "",
          district: "",
          location: "",
          buildingName: "",
          street: "",
          city: "",
          state: "",
          pincode: "",
          email: "",
          mobileNumber: "",
          locationOfSupply: "",
          countryCode: "",
        };
        tempBillingAddress["mobileNumber"] = client?.mobileNumber;
        tempBillingAddress["email"] = client?.email;
        tempBillingAddress["legalName"] = client?.tradeName || client?.legalName || client?.displayName;
        tempBillingAddress["displayName"] = client?.displayName;
        tempBillingAddress["countryCode"] = client?.countryCode;
        tempBillingAddress["billingfulladdress"] = client?.address?.billingfulladdress ? client?.address?.billingfulladdress : "";
        state.shippingAddress = tempBillingAddress;
      }
    },
    handleExistingTermsAndConditions(state: IState, action: PayloadAction<string>) {
      state.termsAndConditionsCopy = state.termsAndConditionsCopy.concat(action.payload);
    },
    handleAddTermsAndConditions(state: IState, action: PayloadAction<string>) {
      state.termsAndConditionsCopy.push(action.payload);
    },
    handleRemoveTermsAndConditions(state: IState, action: PayloadAction<number>) {
      state.termsAndConditionsCopy.splice(action.payload, 1);
    },
    handleUpdateTermsAndConditions(state: IState, action) {
      state.termsAndConditionsCopy = action.payload;
    },
    handleRpsChange(state: IState, action: PayloadAction<any>) {
      state.removedRps.push(action.payload.value);
    },
    handleEditInvoiceDetails(state: IState, action: PayloadAction<any>) {
      state.selectedInvoices = state.selectedInvoices.map(invoice => invoice.id === action.payload.id ? { ...invoice, [action.payload.value.name]: action.payload.value.value } : invoice)
    },
    handleEditInvoicEditeDetails(state: IState, action: PayloadAction<any>) {

      state.invoices =
        state.invoices.map(item => item?.invoice.id === action.payload.id ? { ...item, invoice: { ...item.invoice, [action.payload.value.name]: action.payload.value.value } } : item)
    }
  },
});

export const selectReceipt = (state: RootState) => state.createReceipt;

export const {
  handleChange,
  resetState,
  resetFormFields,
  handleWhatsapp,
  handleClientChange,
  handleExistingClientChange,
  handleBillingEntityChange,
  handleExistingTermsAndConditions,
  handleAddTermsAndConditions,
  handleRemoveTermsAndConditions,
  handleUpdateTermsAndConditions,
  handleInvoiceChnage,
  handleRpsChange,
  handleMail,
  handleAddInvoice,
  handleEditInvoiceDetails,
  handleEditInvoicEditeDetails,
} = createReceiptSlice.actions;

export default createReceiptSlice.reducer;
